import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import ClipLoader from "react-spinners/ClipLoader";
import Footer from ".././Footer.js"
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import swal from "sweetalert";
import { API } from "../../../API.js";
import { isAutheticated } from "../../auth/authhelper";

const AddSoComAdvisor = () => {
    const history = useHistory();
    const { token } = isAutheticated();
    /* ---------------- STATES ---------------- */
    const [loading, setLoading] = useState(false);

    const wordLimit = {
        name: 50,
        description: 200,
    };

    const [remaining, setRemaining] = useState({
        name: wordLimit.name,
        description: wordLimit.description,
    });

    const [advisor, setAdvisor] = useState({
        name: "",
        email: "",
        description: "",
        LinkedIn: "",
        Referral_Agent_Name: "",
        Referral_Agent_Email: "",
        advisorCommission: "",
        networkChannelCommission: "",
        channelCommission: "",

        status: "active",
    });

    /* ---------------- DEFAULT IMAGES ---------------- */
    const ThumbnailURL =
        "https://res.cloudinary.com/duenuiiav/image/upload/v1738589368/tellytell/content_category/tpa6shtnfp9txuekeawo.png";
    const BannerURL =
        "https://res.cloudinary.com/duenuiiav/image/upload/v1738589369/tellytell/content_category/xqznnuqh7g6ozepkorzy.png";

    const [thumbnail, setThumbnail] = useState(null);
    const [banner, setBanner] = useState(null);
    const [logo, setLogo] = useState(null);
    const [billingAdvisor, setBillingAdvisor] = useState({
        registrationFee: "",
        paymentType: "",
        monthlyFee: "",
        sixMonthFee: "",
        bandwidth: "",
        space: "",
    });

    const [billingNetworkChannel, setBillingNetworkChannel] = useState({
        registrationFee: "",
        // paymentType: "",
        monthlyFee: "",
        sixMonthFee: "",
        bandwidth: "",
        space: "",
    });



    // Billing State for Channel
    const [billingChannel, setBillingChannel] = useState({
        Channel_registrationFee: "",
        channel_monthlyFee: "", // removed channel_paymentType
        channel_sixMonthFee: "",
        channel_bandwidth: "",
        channel_space: "",
    });

    // Validations
    const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    /* ---------------- HANDLERS ---------------- */
    const handleText = (e, field) => {
        const value = e.target.value;
        const max = wordLimit[field];

        if (value.length <= max) {
            setAdvisor({ ...advisor, [field]: value });
            setRemaining({ ...remaining, [field]: max - value.length });
        }
    };

    const handleInput = (e) => {
        setAdvisor({ ...advisor, [e.target.name]: e.target.value });
    };

    const handleImage = (e, type) => {
        const file = e.target.files[0];
        if (!file) return;

        if (type === "thumbnail") setThumbnail(file);
        if (type === "banner") setBanner(file);
        if (type === "logo") setLogo(file);
    };

    const removeImage = (type) => {
        if (type === "thumbnail") setThumbnail(null);
        if (type === "banner") setBanner(null);
        if (type === "logo") setLogo(null);
    };
    // Billing handlers
    const handlebillingAdvisorChange = (e) => {
        setBillingAdvisor({ ...billingAdvisor, [e.target.name]: e.target.value });
    };
    const handleBillingNetworkChannelChange = (e) => {
        setBillingNetworkChannel({ ...billingNetworkChannel, [e.target.name]: e.target.value });
    };

    const handleBillingChannelChange = (e) => {
        setBillingChannel({ ...billingChannel, [e.target.name]: e.target.value });
    };

    /* ---------------- SUBMIT (FRONTEND ONLY) ---------------- */
    const validateFormWithSwal = () => {
        // Advisor basic
        if (!advisor.name.trim()) {
            swal("Required", "SoCom Advisor Name is required", "warning");
            return false;
        }

        if (!advisor.Administrator_Name?.trim()) {
            swal("Required", "SoCom Advisor Administrator Name is required", "warning");
            return false;
        }

        if (!advisor.email.trim()) {
            swal("Required", "SoCom Advisor Administrator Email is required", "warning");
            return false;
        }

        if (!isValidEmail(advisor.email)) {
            swal("Invalid Email", "Please enter a valid email address", "error");
            return false;
        }
        if (!advisor.description.trim()) {
            swal("Required", "description is required", "warning");
            return false;
        }
        // OPTIONAL: only validate if value exists
        if (advisor.LinkedIn && advisor.LinkedIn.trim()) {

            const linkedInRegex =
                /^(https?:\/\/)?(www\.)?linkedin\.com\/(in|company)\/[A-Za-z0-9-_%]+\/?$/i;

            if (!linkedInRegex.test(advisor.LinkedIn.trim())) {
                swal(
                    "Invalid LinkedIn URL",
                    "Please enter a valid LinkedIn profile or company URL",
                    "error"
                );
                return false;
            }

        }

        // OPTIONAL: only validate if value exists
        if (advisor.Referral_Agent_Email && advisor.Referral_Agent_Email.trim()) {

            if (!isValidEmail(advisor.Referral_Agent_Email)) {
                swal(
                    "Invalid Email",
                    "Please enter a valid Referral Agent email address",
                    "error"
                );
                return false;
            }

        }

        /* ---------------- Billing – Advisor ---------------- */
        if (!billingAdvisor.registrationFee) {
            swal("Required", "Advisor Registration Fee is required", "warning");
            return false;
        }

        if (!billingAdvisor.paymentType) {
            swal("Required", "Advisor Payment Type is required", "warning");
            return false;
        }

        if (
            billingAdvisor.paymentType === "monthly" &&
            !billingAdvisor.monthlyFee
        ) {
            swal("Required", "Advisor Monthly Fee is required", "warning");
            return false;
        }

        if (
            billingAdvisor.paymentType === "sixMonths" &&
            !billingAdvisor.sixMonthFee
        ) {
            swal("Required", "Advisor 6 Month Fee is required", "warning");
            return false;
        }

        if (!billingAdvisor.bandwidth) {
            swal("Required", "Advisor Bandwidth is required", "warning");
            return false;
        }

        if (!billingAdvisor.space) {
            swal("Required", "Advisor Space is required", "warning");
            return false;
        }

        /* ---------------- Billing – Network Channel ---------------- */
        if (!billingNetworkChannel.registrationFee) {
            swal("Required", "Network Channel Registration Fee is required", "warning");
            return false;
        }

        // if (!billingNetworkChannel.paymentType) {
        //     swal("Required", "Network Channel Payment Type is required", "warning");
        //     return false;
        // }

        if (!billingNetworkChannel.monthlyFee) {
            swal("Required", "Network Channel Monthly Fee is required", "warning");
            return false;
        }

        if (!billingNetworkChannel.sixMonthFee) {
            swal("Required", "Network Channel 6 Month Fee is required", "warning");
            return false;
        }

        if (!billingNetworkChannel.bandwidth) {
            swal("Required", "Network Channel Bandwidth is required", "warning");
            return false;
        }

        if (!billingNetworkChannel.space) {
            swal("Required", "Network Channel Space is required", "warning");
            return false;
        }

        /* ---------------- Billing – Channel ---------------- */
        if (!billingChannel.Channel_registrationFee) {
            swal("Required", "Channel Registration Fee is required", "warning");
            return false;
        }

        if (!billingChannel.channel_monthlyFee) {
            swal("Required", "Channel Monthly Fee is required", "warning");
            return false;
        }

        if (!billingChannel.channel_sixMonthFee) {
            swal("Required", "Channel 6 Month Fee is required", "warning");
            return false;
        }

        if (!billingChannel.channel_bandwidth) {
            swal("Required", "Channel Bandwidth is required", "warning");
            return false;
        }

        if (!billingChannel.channel_space) {
            swal("Required", "Channel Space is required", "warning");
            return false;
        }
        if (!advisor.advisorCommission) {
            swal("Required", "SoCom Advisor Commission is required", "warning");
            return false;
        }

        if (!advisor.networkChannelCommission) {
            swal("Required", "SoCom Advisor network Channel Commission is required", "warning");
            return false;
        }
        if (!advisor.channelCommission) {
            swal("Required", "SoCom Advisor channel Commission is required", "warning");
            return false;
        }

        return true; // ✅ All good
    };

    const submitHandler = async (e) => {
        e.preventDefault();

        // 🔴 STOP if validation fails
        if (!validateFormWithSwal()) return;

        setLoading(true);

        try {
            const formData = new FormData();

            formData.append("name", advisor.name);
            formData.append("Administrator_Name", advisor.Administrator_Name);
            formData.append("email", advisor.email);
            formData.append("description", advisor.description);
            formData.append("LinkedIn", advisor.LinkedIn);
            formData.append("advisorCommission", advisor.advisorCommission);
            formData.append("networkChannelCommission", advisor.networkChannelCommission);
            formData.append("channelCommission", advisor.channelCommission);
            formData.append("status", advisor.status);

            formData.append("billingAdvisor", JSON.stringify(billingAdvisor));
            formData.append("billingNetworkChannel", JSON.stringify(billingNetworkChannel));
            formData.append("billingChannel", JSON.stringify(billingChannel));

            if (thumbnail) formData.append("thumbnail", thumbnail);
            if (banner) formData.append("banner", banner);
            if (logo) formData.append("logo", logo);

            const res = await axios.post(`${API}/api/advisor/add_advisor`, formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (res.data) {
                swal("Success", "SoCom Advisor added successfully!", "success").then(
                    () => {
                        history.push("/SoCom_advisor");
                    }
                );
                setLoading(false);

            }
            history.push("/SoCom_advisor");
        } catch (err) {
            console.error(err);

            // alert();
            swal("Error", err.response?.data?.message || "Something went wrong", "error");
        } finally {
            setLoading(false);
        }
    };


    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid">

                    {/* PAGE HEADER */}
                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-flex align-items-center justify-content-between">
                                <h4 className="mb-0">Content Management - SoCom Advisor</h4>
                                <div className="page-title-right">
                                    <ol className="breadcrumb m-0">
                                        <li className="breadcrumb-item">
                                            <Link to="/dashboard">SoComOTT</Link>
                                        </li>
                                        <li className="breadcrumb-item">Add New SoCom Advisor</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* MAIN LAYOUT */}
                    <div className="row">

                        {/* LEFT BLOCK */}
                        <div className="col-lg-7">
                            <div className="card">
                                <div className="card-body">
                                    <h1 className="head-small mb-3">Add New SoCom Advisor</h1>

                                    <form onSubmit={submitHandler}>

                                        {/* NAME */}
                                        <div className="form-group">
                                            <label>
                                                SoCom Advisor Name <span className="text-danger">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control input-field"
                                                value={advisor.name}
                                                onChange={(e) => handleText(e, "name")}
                                            />
                                            <small className="text-secondary">
                                                Remaining characters: {remaining.name}
                                            </small>
                                        </div>
                                        <div className="form-group">
                                            <label>
                                                SoCom Advisor Administrator Name <span className="text-danger">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control input-field"
                                                name="Administrator_Name"
                                                value={advisor.Administrator_Name}
                                                onChange={handleInput}
                                                required
                                            />
                                        </div>
                                        {/* EMAIL */}
                                        <div className="form-group">
                                            <label>
                                                SoCom Advisor Administrator Email <span className="text-danger">*</span>
                                            </label>
                                            <input
                                                type="email"
                                                className="form-control input-field"
                                                name="email"
                                                value={advisor.email}
                                                onChange={handleInput}
                                                required
                                            />
                                        </div>



                                        {/* DESCRIPTION */}
                                        <div className="form-group">
                                            <label>Description <span className="text-danger">*</span></label>
                                            <textarea
                                                rows="3"
                                                className="form-control input-field"
                                                value={advisor.description}
                                                onChange={(e) => handleText(e, "description")}
                                            />
                                            <small className="text-secondary">
                                                Remaining characters: {remaining.description}
                                            </small>
                                        </div>

                                        {/* HIDDEN LINK */}
                                        <div className="form-group">
                                            <label>LinkedIn URL (optional)</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={advisor.LinkedIn}
                                                name="LinkedIn"
                                                onChange={handleInput}


                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Referral Agent Name (optional)</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={advisor.Referral_Agent_Name}
                                                name="Referral_Agent_Name"
                                                onChange={handleInput}


                                            />
                                        </div>

                                        <div className="form-group">
                                            <label>Referral Agent Email (optional)</label>
                                            <input
                                                type="email"
                                                className="form-control"
                                                value={advisor.Referral_Agent_Email}
                                                name="Referral_Agent_Email"
                                                onChange={handleInput}

                                            />
                                        </div>



                                        {/* THUMBNAIL */}
                                        <div className="form-group">
                                            <label>Thumbnail (320x180 px)</label>
                                            <input
                                                type="file"
                                                className="form-control"
                                                accept="image/*"
                                                onChange={(e) => handleImage(e, "thumbnail")}
                                            />
                                            <div className="mt-2">
                                                <img
                                                    src={thumbnail ? URL.createObjectURL(thumbnail) : ThumbnailURL}
                                                    alt="Thumbnail"
                                                    style={{ maxWidth: "150px", borderRadius: "8px" }}
                                                />
                                                {thumbnail && (
                                                    <button
                                                        type="button"
                                                        className="btn btn-danger btn-sm mt-2"
                                                        onClick={() => removeImage("thumbnail")}
                                                    >
                                                        Remove
                                                    </button>
                                                )}
                                            </div>
                                        </div>

                                        {/* BANNER */}
                                        <div className="form-group">
                                            <label>Banner (1260x750 px)</label>
                                            <input
                                                type="file"
                                                className="form-control"
                                                accept="image/*"
                                                onChange={(e) => handleImage(e, "banner")}
                                            />
                                            <div className="mt-2">
                                                <img
                                                    src={banner ? URL.createObjectURL(banner) : BannerURL}
                                                    alt="Banner"
                                                    style={{ maxWidth: "400px", borderRadius: "6px" }}
                                                />
                                                {banner && (
                                                    <button
                                                        type="button"
                                                        className="btn btn-danger btn-sm mt-2"
                                                        onClick={() => removeImage("banner")}
                                                    >
                                                        Remove
                                                    </button>
                                                )}
                                            </div>
                                        </div>

                                        {/* LOGO */}
                                        <div className="form-group">
                                            <label>Logo (150x60 px)</label>
                                            <input
                                                type="file"
                                                className="form-control"
                                                accept="image/*"
                                                onChange={(e) => handleImage(e, "logo")}
                                            />
                                            <div className="mt-2">
                                                <img
                                                    src={logo ? URL.createObjectURL(logo) : ThumbnailURL}
                                                    alt="Logo"
                                                    style={{ maxWidth: "150px" }}
                                                />
                                                {logo && (
                                                    <button
                                                        type="button"
                                                        className="btn btn-danger btn-sm mt-2"
                                                        onClick={() => removeImage("logo")}
                                                    >
                                                        Remove
                                                    </button>
                                                )}
                                            </div>
                                        </div>

                                        {/* SAVE */}
                                        <button className="btn btn-primary w-100 mt-3">
                                            {loading ? <ClipLoader size={22} color="#fff" /> : "Save"}
                                        </button>

                                    </form>
                                </div>
                            </div>
                        </div>

                        {/* RIGHT BLOCK */}
                        <div className="col-lg-5">
                            <div className="card">
                                <div className="card-body">

                                    <h4 className="mb-3 text-center head-small">Billing - SoCom Advisor</h4>
                                    <form>
                                        {/* Registration Fee */}
                                        <div
                                            className="p-3 mb-3 rounded"
                                            style={{ backgroundColor: "#fdebd0" }}
                                        >
                                            <div className="row mb-3">
                                                <label className="col-sm-6 col-form-label">
                                                    One Time Registration Fee<span className="text-danger">*</span>
                                                </label>
                                                <div className="col-sm-6">
                                                    <div className="input-group">
                                                        <span className="input-group-text">$</span>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            name="registrationFee"
                                                            value={billingAdvisor.registrationFee}
                                                            onChange={handlebillingAdvisorChange}
                                                            min="0"
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Subscription Fee Options (Network Channel) */}
                                        <div
                                            className="p-3 mb-3 rounded"
                                            style={{ backgroundColor: "#d6eaf8" }}
                                        >
                                            <h5 className="mb-3">Subscription Fee</h5>

                                            {/* Monthly Payment */}
                                            <div className="row align-items-center mb-3">
                                                <div className="col-sm-6 d-flex align-items-center gap-2">
                                                    <input
                                                        className="form-check-input ms-1"
                                                        type="radio"
                                                        name="paymentType"
                                                        value="monthly"
                                                        checked={billingAdvisor.paymentType === "monthly"}
                                                        onChange={handlebillingAdvisorChange}
                                                    />
                                                    <label className="mb-0 ms-4">
                                                        Pay Monthly <span className="text-danger">*</span>
                                                    </label>
                                                </div>

                                                <div className="col-sm-6 d-flex justify-content-sm-end">
                                                    <div className="input-group" style={{ maxWidth: 260 }}>
                                                        <span className="input-group-text">$</span>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            name="monthlyFee"
                                                            value={billingAdvisor.monthlyFee}
                                                            onChange={handlebillingAdvisorChange}
                                                            min="0"
                                                            required
                                                            disabled={billingAdvisor.paymentType !== "monthly"}
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            {/* 6 Month Payment */}
                                            <div className="row align-items-center mb-3">
                                                <div className="col-sm-6">



                                                    <input
                                                        className="form-check-input ms-1"
                                                        type="radio"
                                                        name="paymentType"
                                                        value="sixMonths"
                                                        checked={billingAdvisor.paymentType === "sixMonths"}
                                                        onChange={handlebillingAdvisorChange}
                                                    />





                                                    <label className="mb-0 ms-4">
                                                        Pay for 6 Months <span className="text-danger">*</span>
                                                    </label>
                                                </div>

                                                <div className="col-sm-6 d-flex justify-content-sm-end">
                                                    <div className="input-group" style={{ maxWidth: 260 }}>
                                                        <span className="input-group-text">$</span>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            name="sixMonthFee"
                                                            value={billingAdvisor.sixMonthFee}
                                                            onChange={handlebillingAdvisorChange}
                                                            min="0"
                                                            required
                                                            disabled={billingAdvisor.paymentType !== "sixMonths"}
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Bandwidth */}
                                            <div className="row align-items-center mb-3">
                                                <label className="col-sm-6 col-form-label">
                                                    Bandwidth <span className="text-danger">*</span>
                                                </label>

                                                <div className="col-sm-6 d-flex justify-content-sm-end">
                                                    <div className="input-group" style={{ maxWidth: 260 }}>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            name="bandwidth"
                                                            value={billingAdvisor.bandwidth}
                                                            onChange={handlebillingAdvisorChange}
                                                            min="0"
                                                            required
                                                        />
                                                        <span className="input-group-text">GB</span>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Space */}
                                            <div className="row align-items-center">
                                                <label className="col-sm-6 col-form-label">
                                                    Space <span className="text-danger">*</span>
                                                </label>

                                                <div className="col-sm-6 d-flex justify-content-sm-end">
                                                    <div className="input-group" style={{ maxWidth: 260 }}>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            name="space"
                                                            value={billingAdvisor.space}
                                                            onChange={handlebillingAdvisorChange}
                                                            min="0"
                                                            required
                                                        />
                                                        <span className="input-group-text">GB</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </form>
                                    <hr />
                                    <h4 className="mb-3 text-center head-small">Billing - Network Channel</h4>
                                    <form>
                                        {/* Registration Fee */}
                                        <div
                                            className="p-3 mb-3 rounded"
                                            style={{ backgroundColor: "#fdebd0" }}
                                        >
                                            <div className="row mb-3">
                                                <label className="col-sm-6 col-form-label">
                                                    One Time Registration Fee<span className="text-danger">*</span>
                                                </label>
                                                <div className="col-sm-6">
                                                    <div className="input-group">
                                                        <span className="input-group-text">$</span>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            name="registrationFee"
                                                            value={billingNetworkChannel.registrationFee}
                                                            onChange={handleBillingNetworkChannelChange}
                                                            min="0"
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Subscription Fee Options (Network Channel) */}
                                        <div
                                            className="p-3 mb-3 rounded"
                                            style={{ backgroundColor: "#d6eaf8" }}
                                        >
                                            <h5 className="mb-3">Subscription Fee</h5>

                                            {/* Monthly Payment */}
                                            <div className="row align-items-center mb-3">
                                                <div className="col-sm-6 d-flex align-items-center gap-2">
                                                    {/* <input
                                                        className="form-check-input ms-1"
                                                        type="radio"
                                                        name="paymentType"
                                                        value="monthly"
                                                        checked={billingNetworkChannel.paymentType === "monthly"}
                                                        onChange={handleBillingNetworkChannelChange}
                                                    /> */}
                                                    <label className="mb-0">
                                                        Pay Monthly <span className="text-danger">*</span>
                                                    </label>
                                                </div>

                                                <div className="col-sm-6 d-flex justify-content-sm-end">
                                                    <div className="input-group" style={{ maxWidth: 260 }}>
                                                        <span className="input-group-text">$</span>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            name="monthlyFee"
                                                            value={billingNetworkChannel.monthlyFee}
                                                            onChange={handleBillingNetworkChannelChange}
                                                            min="0"
                                                            required
                                                        // disabled={billingNetworkChannel.paymentType !== "monthly"}
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            {/* 6 Month Payment */}
                                            <div className="row align-items-center mb-3">
                                                <div className="col-sm-6">



                                                    {/* <input
                                                        className="form-check-input ms-1"
                                                        type="radio"
                                                        name="paymentType"
                                                        value="sixMonths"
                                                        checked={billingNetworkChannel.paymentType === "sixMonths"}
                                                        onChange={handleBillingNetworkChannelChange}
                                                    /> */}





                                                    <label className="mb-0 ">
                                                        Pay for 6 Months <span className="text-danger">*</span>
                                                    </label>
                                                </div>

                                                <div className="col-sm-6 d-flex justify-content-sm-end">
                                                    <div className="input-group" style={{ maxWidth: 260 }}>
                                                        <span className="input-group-text">$</span>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            name="sixMonthFee"
                                                            value={billingNetworkChannel.sixMonthFee}
                                                            onChange={handleBillingNetworkChannelChange}
                                                            min="0"
                                                            required
                                                        // disabled={billingNetworkChannel.paymentType !== "sixMonths"}
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Bandwidth */}
                                            <div className="row align-items-center mb-3">
                                                <label className="col-sm-6 col-form-label">
                                                    Bandwidth <span className="text-danger">*</span>
                                                </label>

                                                <div className="col-sm-6 d-flex justify-content-sm-end">
                                                    <div className="input-group" style={{ maxWidth: 260 }}>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            name="bandwidth"
                                                            value={billingNetworkChannel.bandwidth}
                                                            onChange={handleBillingNetworkChannelChange}
                                                            min="0"
                                                            required
                                                        />
                                                        <span className="input-group-text">GB</span>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Space */}
                                            <div className="row align-items-center">
                                                <label className="col-sm-6 col-form-label">
                                                    Space <span className="text-danger">*</span>
                                                </label>

                                                <div className="col-sm-6 d-flex justify-content-sm-end">
                                                    <div className="input-group" style={{ maxWidth: 260 }}>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            name="space"
                                                            value={billingNetworkChannel.space}
                                                            onChange={handleBillingNetworkChannelChange}
                                                            min="0"
                                                            required
                                                        />
                                                        <span className="input-group-text">GB</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </form>
                                    <hr />
                                    {/* Billing-Channel Section */}
                                    <h4 className="mb-3 text-center head-small">Billing - Channel</h4>
                                    <form>
                                        <div
                                            className="p-3 mb-3 rounded"
                                            style={{ backgroundColor: "#fdebd0" }}
                                        >
                                            <div className="row mb-3 ">
                                                <label className="col-sm-6 col-form-label">
                                                    One Time Registration Fee<span className="text-danger">*</span>
                                                </label>
                                                <div className="col-sm-6">
                                                    <div className="input-group">
                                                        <span className="input-group-text">$</span>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            name="Channel_registrationFee"
                                                            value={billingChannel.Channel_registrationFee}
                                                            onChange={handleBillingChannelChange}
                                                            min="0"
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div
                                            className="p-3 mb-3 rounded"
                                            style={{ backgroundColor: "#d6eaf8" }}
                                        >
                                            <h5 className="mb-3">Channel Subscription Fee</h5>

                                            {/* Channel Monthly option row */}
                                            <div className="row align-items-center mb-2">
                                                <div className="col-sm-6">
                                                    <label className="mb-0">Pay Monthly<span className="text-danger">*</span></label>
                                                </div>
                                                <div className="col-sm-6">
                                                    <div className="input-group" style={{ maxWidth: 260 }}>
                                                        <span className="input-group-text">$</span>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            name="channel_monthlyFee"
                                                            value={billingChannel.channel_monthlyFee}
                                                            onChange={handleBillingChannelChange}
                                                            min="0"
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Channel 6-month option row */}
                                            <div className="row align-items-center mb-3">
                                                <div className="col-sm-6">
                                                    <label className="mb-0">Pay for 6 Months<span className="text-danger">*</span></label>
                                                </div>
                                                <div className="col-sm-6">
                                                    <div className="input-group" style={{ maxWidth: 260 }}>
                                                        <span className="input-group-text">$</span>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            name="channel_sixMonthFee"
                                                            value={billingChannel.channel_sixMonthFee}
                                                            onChange={handleBillingChannelChange}
                                                            min="0"
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Channel Bandwidth */}
                                            <div className="row mb-3">
                                                <label className="col-sm-6 col-form-label">
                                                    Channel Bandwidth<span className="text-danger">*</span>
                                                </label>
                                                <div className="col-sm-6">
                                                    <div className="input-group">
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            name="channel_bandwidth"
                                                            value={billingChannel.channel_bandwidth}
                                                            onChange={handleBillingChannelChange}
                                                            min="0"
                                                            required
                                                        />
                                                        <span className="input-group-text">GB</span>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Channel Space */}
                                            <div className="row mb-3">
                                                <label className="col-sm-6 col-form-label">
                                                    Channel Space<span className="text-danger">*</span>
                                                </label>
                                                <div className="col-sm-6">
                                                    <div className="input-group">
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            name="channel_space"
                                                            value={billingChannel.channel_space}
                                                            onChange={handleBillingChannelChange}
                                                            min="0"
                                                            required
                                                        />
                                                        <span className="input-group-text">GB</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-body">
                                    <h4 className="mb-3 text-center head-small">
                                        Commisions
                                    </h4>

                                    <div
                                        className="p-3 rounded mb-3"
                                        style={{ backgroundColor: "#fdebd0" }}
                                    >
                                        <label>SoCom Advisor Commission (%) <span className="text-danger">*</span></label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            name="advisorCommission"
                                            value={advisor.advisorCommission}
                                            onChange={handleInput}
                                        />
                                    </div>
                                    <div
                                        className="p-3 rounded mb-3"
                                        style={{ backgroundColor: "#d6eaf8" }}
                                    >
                                        <label>Network Channel Commission (%) <span className="text-danger">*</span></label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            name="networkChannelCommission"
                                            value={advisor.networkChannelCommission}
                                            onChange={handleInput}
                                        />
                                    </div>
                                    <div
                                        className="p-3 rounded"
                                        style={{ backgroundColor: "#d6eaf8" }}
                                    >
                                        <label>Channel Commission To Pay (%) <span className="text-danger">*</span></label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            name="channelCommission"
                                            value={advisor.channelCommission}
                                            onChange={handleInput}
                                        />
                                    </div>

                                    {/* <div className="alert alert-info small mt-3">
                                        Pricing is stored & displayed only.
                                        No calculation logic implemented.
                                    </div> */}
                                </div>
                            </div>
                            {/* STATUS */}
                            {/* <div
                                className="p-3 mb-3 rounded"
                                style={{ backgroundColor: "#e8f8f5" }}
                            >
                                <label className="form-label fw-semibold">
                                    Advisor Status
                                </label>

                                <select
                                    className="form-select"
                                    name="status"
                                    value={advisor.status}
                                    onChange={handleInput}
                                >
                                    <option value="active">Active</option>
                                    <option value="inactive">Inactive</option>
                                    <option value="suspended">Suspended</option>
                                </select>

                                <small className="text-muted">
                                    Status controls advisor visibility & access
                                </small>
                            </div> */}

                        </div>

                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default AddSoComAdvisor;
